import { Button } from '@factorialco/deprecated-design-system'
import { ItemIntegrationFragment } from 'generated/resources/graphql'

import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

interface CompanyInstallationProps {
  integration: ItemIntegrationFragment
}

export const ExternalIntegrationInstallButton = ({ integration }: CompanyInstallationProps) => {
  const redirectURL = integration.setUpIntegrationEndpoint

  const trackEvent = () => {
    track(trackingEvents.marketplace.clickIntegrationSetUp, {
      integrationDatoId: integration.datoId,
      integrationName: integration.name,
    })
  }

  return (
    <Button
      type="upgrade"
      onClick={() => {
        trackEvent()
        redirectURL && window.open(redirectURL)
      }}
    >
      {i18n.t('marketplace.integrations.set_up_integration')}
    </Button>
  )
}
